import { apiClient } from "@/lib/apiClient";

export interface Role {
  id: string;
  name: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

class RoleApiService {
  async getAllRoles(): Promise<Role[]> {
    return apiClient.get<Role[]>("/v1/roles");
  }

  async getRole(id: string): Promise<Role> {
    return apiClient.get<Role>(`/v1/roles/${id}`);
  }
}

export const roleApi = new RoleApiService();
